import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Car, ArrowRight } from "lucide-react";
import { business } from "../mock";
import { serviceLinks } from "../data/servicePages";

const Footer = () => {
  return (
    <footer className="bg-[#1f1f1f] text-gray-400">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Link to="/" className="flex items-center gap-3 mb-5">
            <div className="w-11 h-11 rounded-xl bg-[#84bd00] flex items-center justify-center">
              <Car size={24} className="text-white" />
            </div>
            <div className="leading-tight">
              <div className="text-white font-display font-extrabold text-lg">
                DENTCRAFT <span className="text-[#84bd00]">NSW</span>
              </div>
              <div className="text-gray-500 text-[10px] tracking-widest uppercase">Paintless Dent Removal</div>
            </div>
          </Link>
          <p className="text-sm leading-relaxed">
            Mobile paintless dent repair specialists restoring damaged car panels and dings at your home or workplace across West Sydney &amp; Sydney Metro.
          </p>
          <a href={business.facebook} target="_blank" rel="noreferrer" className="mt-5 inline-flex w-9 h-9 rounded-full bg-white/10 items-center justify-center hover:bg-[#84bd00] transition-colors">
            <Facebook size={16} className="text-white" />
          </a>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-5">Our Services</h4>
          <ul className="space-y-3 text-sm">
            {serviceLinks.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="inline-flex items-center gap-2 hover:text-[#84bd00] transition-colors">
                  <ArrowRight size={14} className="text-[#84bd00]" /> {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-5">Service Areas</h4>
          <ul className="space-y-3 text-sm">
            {["Western Sydney", "Sydney Metro", "Canterbury", "Liverpool", "Blacktown", "Penrith"].map((a) => (
              <li key={a} className="inline-flex items-center gap-2">
                <MapPin size={14} className="text-[#84bd00]" /> {a}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-5">Get In Touch</h4>
          <ul className="space-y-4 text-sm">
            <li>
              <a href={`tel:${business.phoneRaw}`} className="flex items-start gap-3 hover:text-[#84bd00] transition-colors">
                <Phone size={16} className="text-[#84bd00] mt-0.5" /> {business.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${business.email}`} className="flex items-start gap-3 hover:text-[#84bd00] transition-colors break-all">
                <Mail size={16} className="text-[#84bd00] mt-0.5" /> {business.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#84bd00] mt-0.5" /> {business.address}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-gray-500">
          <span>&copy; {new Date().getFullYear()} Dentcraft NSW Pty Ltd. All rights reserved.</span>
          <span>Fully licensed &amp; insured • Recommended by major insurers</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
